import React, { useEffect, useState, useCallback } from 'react';
import DataTable from './DataTable';
import axiosInstance from '../utils/axiosInstance';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';

const POLLING_INTERVAL = 10000;

const PendingRequests = () => {
    const [data,         setData]         = useState([]);
    const [loading,      setLoading]      = useState(true);
    const [rejectId,     setRejectId]     = useState(null);
    const [rejectReason, setRejectReason] = useState('');

    const fetchPendingRequests = useCallback(async () => {
        try {
            const response = await axiosInstance.get('/request');
            const sorted   = response.data
                .filter(r => r.status === 'pending')
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setData(sorted);
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPendingRequests();
        const iv = setInterval(fetchPendingRequests, POLLING_INTERVAL);
        return () => clearInterval(iv);
    }, [fetchPendingRequests]);

    const handleApprove = async (username) => {
        if (!window.confirm(`${username} talebini onaylıyor musunuz?`)) return;
        const t = toast.loading('İşlem yapılıyor...');
        try {
            const r = await axiosInstance.post('/request/update', { username, status: 'approved', rejectReason: 'Manuel onaylama' });
            if (r.status === 200) {
                toast.update(t, { render: 'Talep onaylandı!', type: 'success', isLoading: false, autoClose: 3000 });
                fetchPendingRequests();
            }
        } catch { toast.update(t, { render: 'Hata oluştu!', type: 'error', isLoading: false, autoClose: 3000 }); }
    };

    const handleReject = async () => {
        if (!rejectReason.trim()) { toast.warn('Lütfen bir red nedeni girin!'); return; }
        const t = toast.loading('Red işlemi yapılıyor...');
        try {
            await axiosInstance.post('/request/update', { username: rejectId, status: 'rejected', rejectReason });
            toast.update(t, { render: 'Talep reddedildi.', type: 'error', isLoading: false, autoClose: 3000 });
            fetchPendingRequests();
            setRejectId(null);
            setRejectReason('');
        } catch { toast.update(t, { render: 'İşlem başarısız!', type: 'warning', isLoading: false, autoClose: 3000 }); }
    };

    if (loading && data.length === 0)
        return <div style={{ minHeight: '100vh', background: '#090a0c', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,.3)', fontFamily: 'Inter,sans-serif' }}>Yükleniyor...</div>;

    return (
        <>
            <ToastContainer theme="dark" position="top-right" />

            <DataTable
                title="Bekleyen Talepler"
                data={data}
                isPendingPage={true}
                fetchData={fetchPendingRequests}
                handleApprove={handleApprove}
                openRejectModal={setRejectId}
            />

            {/* ── Red Modal ─────────────────────────────────── */}
            {rejectId && (
                <div onClick={() => { setRejectId(null); setRejectReason(''); }} style={{
                    position: 'fixed', inset: 0, zIndex: 10000,
                    background: 'rgba(0,0,0,.75)', backdropFilter: 'blur(10px)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    animation: 'fadeIn .2s ease both',
                }}>
                    <style>{`
                        @keyframes fadeIn { from{opacity:0;transform:scale(.96)} to{opacity:1;transform:none} }
                        .modal-textarea:focus { border-color: #ef4444 !important; box-shadow: 0 0 0 3px rgba(239,68,68,.12) !important; outline: none !important; }
                    `}</style>

                    <div onClick={e => e.stopPropagation()} style={{
                        width: '100%', maxWidth: 460,
                        background: '#111318',
                        border: '1px solid rgba(239,68,68,.2)',
                        borderRadius: 22,
                        boxShadow: '0 32px 80px rgba(0,0,0,.7), 0 0 0 1px rgba(255,255,255,.04)',
                        overflow: 'hidden',
                        fontFamily: "'Outfit','Inter',sans-serif",
                    }}>
                        {/* Modal header */}
                        <div style={{
                            padding: '22px 24px 18px',
                            borderBottom: '1px solid rgba(255,255,255,.05)',
                            display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <div style={{
                                    width: 40, height: 40, borderRadius: 11,
                                    background: 'rgba(239,68,68,.12)', border: '1px solid rgba(239,68,68,.25)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: '#ef4444', fontSize: '1rem', flexShrink: 0,
                                }}><FaExclamationTriangle /></div>
                                <div>
                                    <div style={{ fontWeight: 700, fontSize: '.95rem', color: '#f8fafc' }}>Talebi Reddet</div>
                                    <div style={{ fontSize: '.72rem', color: 'rgba(255,255,255,.3)', marginTop: 2 }}>
                                        <span style={{ color: '#f27127', fontWeight: 600 }}>{rejectId}</span> için açıklama girin
                                    </div>
                                </div>
                            </div>
                            <button onClick={() => { setRejectId(null); setRejectReason(''); }} style={{
                                width: 30, height: 30, borderRadius: 8, border: 'none', cursor: 'pointer',
                                background: 'rgba(255,255,255,.06)', color: 'rgba(255,255,255,.35)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.8rem',
                            }}><FaTimes /></button>
                        </div>

                        {/* Body */}
                        <div style={{ padding: '20px 24px 24px' }}>
                            <textarea
                                className="modal-textarea"
                                value={rejectReason}
                                onChange={e => setRejectReason(e.target.value)}
                                placeholder="Red sebebini buraya yazın..."
                                autoFocus
                                rows={4}
                                style={{
                                    width: '100%', padding: '13px 15px',
                                    background: '#0d0e12', border: '1px solid rgba(255,255,255,.08)',
                                    borderRadius: 12, color: '#e2e8f0', fontSize: '.85rem',
                                    fontFamily: 'inherit', resize: 'vertical',
                                    transition: 'border-color .2s, box-shadow .2s',
                                    marginBottom: 16,
                                }}
                            />

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                                <button onClick={() => { setRejectId(null); setRejectReason(''); }} style={{
                                    padding: '11px', borderRadius: 11, border: '1px solid rgba(255,255,255,.08)',
                                    background: 'rgba(255,255,255,.05)', color: 'rgba(255,255,255,.5)',
                                    fontSize: '.82rem', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
                                    transition: 'all .15s',
                                }}>Vazgeç</button>
                                <button onClick={handleReject} style={{
                                    padding: '11px', borderRadius: 11, border: 'none',
                                    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                                    color: '#fff', fontSize: '.82rem', fontWeight: 700,
                                    cursor: 'pointer', fontFamily: 'inherit',
                                    boxShadow: '0 4px 16px rgba(239,68,68,.3)',
                                    transition: 'all .15s',
                                }}>Talebi Reddet</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PendingRequests;
